import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInventoryFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.89999 3.25C2.99779 3.25 2.24999 3.97525 2.24999 4.88889V6.36111C2.24999 7.27475 2.99779 8 3.89999 8H20.1C21.0022 8 21.75 7.27475 21.75 6.36111V4.88889C21.75 3.97525 21.0022 3.25 20.1 3.25H3.89999ZM3.44999 18.26V9H20.55V18.26C20.55 19.6623 19.4023 20.75 18 20.75H6C4.59765 20.75 3.44999 19.6623 3.44999 18.26ZM8.53846 11.0769C8.53846 10.6946 8.84842 10.3846 9.23077 10.3846H14.7692C15.1516 10.3846 15.4615 10.6946 15.4615 11.0769C15.4615 11.4593 15.1516 11.7692 14.7692 11.7692H9.23077C8.84842 11.7692 8.53846 11.4593 8.53846 11.0769Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgInventoryFilled);
export default ForwardRef;
